@if (bankingDetails; as details) {
  <hr />
  <div class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 g-3 mb-4">
    @for (item of bankFields; track item) {
      <div class="col">
        <app-info-block
          [label]="item.label"
          [value]="item.value"
          [placeholder]="item.placeholder"
          [showButton]="item.is_proof && !!details.proof">
          @if (item.is_proof && details.proof) {
            <ng-container button>
              <a
                [href]="details.proof_download_url"
                rel="noopener"
                target="_blank"
                class="btn btn-sm btn-light text-secondary">
                View
              </a>
            </ng-container>
          }
        </app-info-block>
      </div>
    }
  </div>
} @else {
  <div class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 g-3 mb-4">
    @for (item of bankFields; track item) {
      <div class="col">
        <app-info-block
          [label]="item.label"
          [placeholder]="item.placeholder"
          [showButton]="false">
        </app-info-block>
      </div>
    }
  </div>
}

<hr />
<div class="mt-3 text-end">
  <button
    id="editBankingDetails"
    (click)="onEditBankingDetails()"
    class="btn btn-primary">
    {{ bankingDetails ? 'Edit' : 'Add' }} banking details
  </button>
</div>
